import { render, staticRenderFns } from "./Partners.sendEmail.vue?vue&type=template&id=5b9aaaa0"
import script from "./Partners.sendEmail.vue?vue&type=script&lang=js"
export * from "./Partners.sendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports